module.exports = __webpack_public_path__ + "static/media/logomark.b92fd9fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/logomark.svg
// module id = 177
// module chunks = 0